import { useEffect, useState } from 'preact/compat'
import { useSelector } from 'react-redux'

/**
 * Resolves the list of components to render, from the `components` MFE
 * attribute when the tenant provides one, otherwise from the BE response.
 *
 * Entries are normalised (trimmed, empties dropped) so that `elements` is
 * canonical for every consumer. Previously only the render path trimmed, while
 * the readiness bookkeeping in App (`elements.includes('details')`) and
 * `pageState.availableComponents` saw raw entries: for
 * `components="title, methods, details"` they received `' methods'` / `' details'`
 * and therefore believed those components were absent, force-setting
 * isDetailsReady / isPaymentMethodsReady to true for components that were in
 * fact being rendered.
 */
export default function useComponents(components) {
  const transactionDetails = useSelector(state => state.transactionDetails)
  const [elements, setElements] = useState([])

  useEffect(() => {
    const normalise = list =>
      (list || []).map(item => item?.trim()).filter(Boolean)

    const componentsFromAttribute = normalise(components?.split(','))
    const componentsFromResponse = normalise(
      transactionDetails?.displayedComponents,
    )

    setElements(
      componentsFromAttribute.length
        ? componentsFromAttribute
        : componentsFromResponse,
    )
  }, [components, transactionDetails?.displayedComponents])

  return elements
}
